import { useThemeData as _useThemeData, useThemeLocaleData as _useThemeLocaleData, } from '@vuepress/plugin-theme-data/lib/client';
export const useThemeData = () => _useThemeData();
export const useThemeLocaleData = () => _useThemeLocaleData();
